var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var positiveInteger = function (value) {
    var number = typeof value === 'number' ? value : typeof value === 'string' && value.trim() ? Number(value) : NaN;
    return isFinite(number) && Number.isInteger(number) && number > 0 ? number : undefined;
};
// Branch IDs (4.1, 4.2) belong to the same visible stage (4).
var mainStage = function (value) {
    if (typeof value !== 'number' && typeof value !== 'string')
        return undefined;
    var id = String(value).trim();
    if (!/^\d+(?:\.\d+)*$/.test(id))
        return undefined;
    return positiveInteger(id.split('.')[0]);
};
export var getOnboardingProgress = function (form, currentStep) {
    var stage = mainStage(currentStep === null || currentStep === void 0 ? void 0 : currentStep.step);
    if (!stage)
        return null;
    var steps = form === null || form === void 0 ? void 0 : form.steps;
    var reportedTotal = positiveInteger(form === null || form === void 0 ? void 0 : form.countSteps);
    if (steps === null || steps === void 0 ? void 0 : steps.length) {
        var roots_1 = steps.map(function (item) { return mainStage(item.step); });
        // IDs identify stages; nextStepId determines their order (e.g. 3 -> 6 -> 5 -> 4).
        var stages_1 = [];
        var visited_1 = new Set();
        var terminalRoots_1 = new Set(steps.filter(function (item) { return item.type === 'SUCCESS'; }).map(function (item) { return mainStage(item.step); }));
        var targets_1 = new Set(steps.flatMap(function (item) { return __spreadArray([item.nextStepId], (item.fields || []).map(function (field) { return field.nextStepId; }), true); })
            .map(mainStage).filter(function (root) { return root !== undefined; }));
        var visit_1 = function (root) {
            if (!root || visited_1.has(root) || !roots_1.includes(root))
                return;
            visited_1.add(root);
            if (!terminalRoots_1.has(root))
                stages_1.push(root);
            steps.filter(function (item) { return mainStage(item.step) === root; }).forEach(function (item) {
                visit_1(mainStage(item.nextStepId));
                (item.fields || []).forEach(function (field) { return visit_1(mainStage(field.nextStepId)); });
            });
        };
        roots_1.filter(function (root) { return root && !targets_1.has(root); }).forEach(visit_1);
        roots_1.forEach(visit_1);
        roots_1.forEach(function (root) {
            if (root && terminalRoots_1.has(root) && !stages_1.includes(root))
                stages_1.push(root);
        });
        var terminalStage = steps
            .filter(function (item) { return item.type === 'SUCCESS'; })
            .map(function (item) { return mainStage(item.step); })
            .find(Boolean);
        var completeList = roots_1.every(Boolean) && (reportedTotal === steps.length || Boolean(terminalStage));
        if (completeList) {
            var position = stages_1.indexOf(stage);
            return position >= 0 ? { currentStep: position + 1, totalSteps: stages_1.length } : null;
        }
    }
    // Partial responses without a terminal step cannot establish a new total.
    return reportedTotal && stage <= reportedTotal ? { currentStep: stage, totalSteps: reportedTotal } : null;
};
